import { render } from "./SubScenarioForm.vue?vue&type=template&id=60fc0266"
import script from "./SubScenarioForm.vue?vue&type=script&lang=js"
export * from "./SubScenarioForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__